import FilterPluginSetup from "./filter/PluginSetup.js";
import SortPluginSetup from "./sort/PluginSetup.js";
export default {
  install(molten) {
    FilterPluginSetup.install(molten);
    SortPluginSetup.install(molten);
  }
};